import { UpdateMainConsignee, UpdateMainShipper } from './hawb.state';
import {
  DispList,
  CommodityList,
  Miscellaneous,
  Pod,
  hawbInformation,
  CommodityMiscellaneous,
  EventList,
  HawbSearchPayload,
  HawbInformationSearchPayload,
  Roles,
  PieceList,
  ScanHistoryFilter,
  ScanShipmentRecord,
  PendingHawbRouteUpdate,
} from 'src/app/features/model/hawb.model';

export class AddRoles {
  static readonly type = '[Roles] Add';
  constructor(public payload: Roles) {}
}

export class ResetRoles {
  static readonly type = '[Roles] Reset';
}

export class DeleteRoles {
  static readonly type = '[Roles] Delete';
  constructor(public payload: Roles) {}
}

// Disp Section
export class AddDispCode {
  static readonly type = '[Disp Codes] Add Disp Code';
  constructor(public payload: DispList) {}
}

export class DeleteStatusCode {
  static readonly type = '[Status Codes] Delete Status Code';
  constructor(public id: any) {}
}
export class ResetDispCodes {
  static readonly type = '[Disp Codes] Reset Disp Codes';
}
// POD Section
export class AddPodCode {
  static readonly type = '[POD Codes] Add POD Code';
  constructor(public payload: Pod) {}
}

export class DeletePodCode {
  static readonly type = '[POD Codes] Delete POD Code';
  constructor(public id: any) {}
}
export class ResetPODCodes {
  static readonly type = '[POD Codes] Reset POD Codes';
}
export class RemoveUnsavedAttachments {
  static readonly type = '[Attachment] Remove Unsaved Attachments';
}
export class ResetAtatchmnetCodes {
  static readonly type = '[Attachment Codes] Reset Attachment Codes';
}
// Miscellaneous Section
export class UpdateMiscellaneous {
  static readonly type = '[Miscellaneous] Update';
  constructor(public payload: Miscellaneous) {}
}
// Hawb Information Crud
export class UpdateHawbInformation {
  static readonly type = '[HawbInformation] Update';
  constructor(public payload: Partial<hawbInformation>) {}
}

// Commodity Table
export class AddCommodity {
  static readonly type = '[Commodity] Add';
  constructor(public payload: CommodityList) {}
}

export class AddPieces {
  static readonly type = '[Piece] Add';
  constructor(public payload: PieceList[]) {}
}

export class ResetPieces {
  static readonly type = '[Piece] Reset';
}

export class ResetCommodity {
  static readonly type = '[Commodity] Reset';
}

export class DeleteCommodity {
  static readonly type = '[Commodity] Delete Commodity';
  constructor(public payload: number) {}
}

// Miscellaneous Commodity
export class AddMiscellaneousCommodity {
  static readonly type = '[Miscellaneous Commodity] Add';
  constructor(public payload: CommodityMiscellaneous) {}
}

export class RemoveUnsavedMiscellaneousCommodities {
  static readonly type = '[Miscellaneous Commodity] Remove Unsaved';
}
export class ResetMiscellaneousCommodity {
  static readonly type = '[Miscellaneous Commodity] Reset';
}

export class AddEvents {
  static readonly type = '[Events] Add';
  constructor(public payload: EventList[]) {}
}
export class ResetEvents {
  static readonly type = '[Events] Reset Events';
}

export class FetchHawbsList {
  static readonly type = '[Hawbs] List';
  constructor(public payload: HawbSearchPayload) {}
}

export class FetchHawbsInformationListSuccess {
  static readonly type = '[Hawb] Fetch Hawbs Information List Success';
  constructor(public hawbs: hawbInformation[]) {}
}

export class FetchHawbsInformationList {
  static readonly type = '[Hawbs] Information List';
  constructor(public payload: HawbInformationSearchPayload) {}
}

export class FetchHawbsInformationByHawbExt {
  static readonly type = '[Hawbs] Information Lit by Hawb EXT';
  constructor(public payload: string) {}
}

export class ResetHawbsList {
  static readonly type = '[Hawbs] Reset Hawbs List';
}

export class FetchSelectedHawbById {
  static readonly type = '[Hawbs] Fetch Selected Hawb By Id';
  constructor(public hawbId: number) {}
}

export class ResetHawbInfo {
  static readonly type = '[Hawbs] Reset Hawbs Info';
}

export class MainConsigneeShipperScreenActions {
  static updateConsignee(payload: any) {
    return new UpdateMainConsignee(payload);
  }

  static updateShipper(payload: any) {
    return new UpdateMainShipper(payload);
  }
}

export class FetchDropdowns {
  static readonly type = '[Hawbs] Fetch Dropdowns';
  constructor(public payload: any) {}
}

export class SavedRoutesData {
  static readonly type = '[Routes] Save Routes Data';
  constructor(public payload: any) {}
}

export class ResetRoutesData {
  static readonly type = '[Routes] Reset Routes Data';
}

export class SaveSelectedRoute {
  static readonly type = '[Routes] Save Selected Route';
  constructor(public payload: any) {}
}

export class ResetSelectedRoute {
  static readonly type = '[Routes] Reset Selected Route';
}

export class SetAvailableRoutes {
  static readonly type = '[Routes] Set Available Routes';
  constructor(public payload: any) {}
}

export class ResetAvailableRoutes {
  static readonly type = '[Routes] Reset Available Routes';
}

export class SetPendingRouteUpdate {
  static readonly type = '[Routes] Set Pending Route Update';
  constructor(public payload: PendingHawbRouteUpdate | null) {}
}

// SPEC-SSS-001: Scan Shipments session
export class RecordScan {
  static readonly type = '[Scan Shipments] Record Scan';
  constructor(public payload: Omit<ScanShipmentRecord, 'scanId'>) {}
}

export class ResetScanSession {
  static readonly type = '[Scan Shipments] Reset Session';
}

export class ClearScanSession {
  static readonly type = '[Scan Shipments] Clear Session';
}

export class SetVoiceFeedback {
  static readonly type = '[Scan Shipments] Set Voice Feedback';
  constructor(public payload: boolean) {}
}

export class SetCanvasAlerts {
  static readonly type = '[Scan Shipments] Set Canvas Alerts';
  constructor(public payload: boolean) {}
}

export class SetHistoryFilter {
  static readonly type = '[Scan Shipments] Set History Filter';
  constructor(public payload: ScanHistoryFilter) {}
}
